(function () {
  'use strict';

  var COLOR_MAP = {
    'Shiny Pink':    '#F1C9C9',
    'Soft Black':    '#303538',
    'Soft Espresso': '#514242',
    'Sky Blue':      '#B9D9EA',
    'Lavender':      '#D6C7E8',
    'Roze':          '#F1C9C9',
    'Zwart':         '#303538',
    'Wit':           '#FFFFFF',
  };

  // Variant option names are translated per locale, so prefer the SKU
  // (identical in every language) and fall back to COLOR_MAP by name.
  var SKU_COLOR_MAP = {
    'YUM65':  '#F1C9C9', // Shiny Pink
    'YUM66':  '#303538', // Soft Black
    'YUM111': '#514242', // Soft Espresso
    'YUM109': '#B9D9EA', // Sky Blue
    'YUM110': '#D6C7E8', // Lavender
  };

  var allVariants = [], swatchData = [], selectedIds = [], activeQty = 1, interceptAttached = false;
  var ITEM_LABEL = 'Brush';
  var GRATIS_LABEL = '';
  var SEL_BUNDLE_WRAP  = '.bundle-options';
  var SEL_BUNDLE_INPUT = '.bundle-option__input';
  var SEL_VISUAL_BTN   = '.visual-option-btn';
  var SEL_PRODUCT_FORM = 'form[id*="product-form"]';
  var SEL_BC_WRAP      = '.bc-wrap';

  function boot() {
    var bundleWrap = document.querySelector(SEL_BUNDLE_WRAP);
    if (!bundleWrap) return;
    ITEM_LABEL = bundleWrap.dataset.multiColorItemLabel || ITEM_LABEL;
    GRATIS_LABEL = bundleWrap.dataset.gratisLabel || '';
    loadVariants();
    buildSwatchData();
    if (!swatchData.length) return;
    // Lets the mobile sticky ATC modal draw the same swatches as the buy box.
    window.BundleMultiColor = { swatches: swatchData };
    document.addEventListener('change', onBundleChange);
    document.addEventListener('click',  onTopSwatchClick);
    attachCartIntercept();
    injectCSS();
    var checked = document.querySelector(SEL_BUNDLE_INPUT + ':checked');
    if (checked) {
      activeQty = parseInt(checked.dataset.quantity, 10) || 1;
      if (activeQty > 1) renderSelectors(activeQty, checked);
    }
  }

  function loadVariants() {
    var el = document.querySelector('script.variant-data');
    if (el) { try { allVariants = JSON.parse(el.textContent); } catch (_) {} }
  }

  function buildSwatchData() {
    var seen = {};
    document.querySelectorAll(SEL_VISUAL_BTN).forEach(function (btn) {
      var value = btn.dataset.value;
      if (!value || seen[value]) return;
      seen[value] = true;
      var available = btn.dataset.available !== 'false';
      var variant = allVariants.find(function (v) { return v.option1 === value || v.title === value; });
      swatchData.push({
        value: value,
        color: (variant && SKU_COLOR_MAP[variant.sku]) || COLOR_MAP[value] || '#cccccc',
        available: variant ? variant.available : available,
        variantId: variant ? variant.id : null,
      });
    });
  }

  function currentTopColor() {
    var active = document.querySelector(SEL_VISUAL_BTN + '.active');
    return active ? active.dataset.value : (swatchData[0] ? swatchData[0].value : '');
  }

  function variantByColor(colorName) {
    var match = swatchData.find(function (c) { return c.value === colorName; });
    return match ? match.variantId : null;
  }

  function onBundleChange(e) {
    if (!e.target.matches(SEL_BUNDLE_INPUT)) return;
    activeQty = parseInt(e.target.dataset.quantity, 10) || 1;
    destroySelectors();
    if (activeQty > 1) renderSelectors(activeQty, e.target);
  }

  var suppressTopSwatchSync = false;

  function onTopSwatchClick(e) {
    var btn = e.target.closest(SEL_VISUAL_BTN);
    if (!btn || btn.closest(SEL_BC_WRAP)) return;
    if (activeQty <= 1) return;
    if (suppressTopSwatchSync) return;
    setTimeout(syncSlotsToTopColor, 0);
  }

  function syncSlotsToTopColor() {
    var color = currentTopColor();
    selectedIds = selectedIds.map(function () { return variantByColor(color); });
    document.querySelectorAll('.bc-row').forEach(function (row) {
      var nameEl = row.querySelector('.bc-label__color');
      if (nameEl) nameEl.textContent = color;
      row.querySelectorAll('.bc-swatch').forEach(function (s) {
        s.classList.toggle('bc-swatch--active', s.dataset.value === color);
      });
    });
  }

  function renderSelectors(qty, radioInput) {
    destroySelectors();
    var color = currentTopColor();
    var vid = variantByColor(color);
    selectedIds = [];
    for (var i = 0; i < qty; i++) selectedIds.push(vid);
    var optionDiv = radioInput.closest('.bundle-option');
    // Free-gift bundles (e.g. "3 for 2") mark the last slot as the free item —
    // only when the gratis_label metafield is filled in (it supplies the badge text).
    var hasGift = !!(optionDiv && optionDiv.querySelector('.bundle-option__gift-section') && GRATIS_LABEL);
    var wrap = document.createElement('div');
    wrap.className = 'bc-wrap';
    for (var j = 0; j < qty; j++) { wrap.appendChild(buildRow(j, color, hasGift && j === qty - 1)); }
    var target = optionDiv && optionDiv.querySelector('.bundle-option__content');
    if (target) { target.appendChild(wrap); }
    else { document.querySelector(SEL_BUNDLE_WRAP).insertAdjacentElement('afterend', wrap); }
  }

  function destroySelectors() {
    var el = document.querySelector(SEL_BC_WRAP);
    if (el) el.remove();
    selectedIds = [];
  }

  function buildRow(slotIdx, defaultColor, isFreeSlot) {
    var row = document.createElement('div');
    row.className = 'bc-row';
    row.dataset.slot = slotIdx;
    var label = document.createElement('div');
    label.className = 'bc-label';
    var brushSpan = document.createElement('span');
    brushSpan.className = 'bc-label__brush';
    brushSpan.textContent = ITEM_LABEL + ' ' + (slotIdx + 1) + ':';
    var colorSpan = document.createElement('span');
    colorSpan.className = 'bc-label__color';
    colorSpan.textContent = ' ' + defaultColor;
    label.appendChild(brushSpan);
    label.appendChild(colorSpan);
    if (isFreeSlot) {
      var freeBadge = document.createElement('span');
      freeBadge.className = 'bc-label__free';
      freeBadge.textContent = GRATIS_LABEL;
      label.appendChild(freeBadge);
    }
    var swatches = document.createElement('div');
    swatches.className = 'bc-swatches';
    swatchData.forEach(function (opt) {
      var isActive = opt.value === defaultColor;
      var isDisabled = !opt.available;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bc-swatch' + (isActive ? ' bc-swatch--active' : '') + (isDisabled ? ' bc-swatch--disabled' : '');
      btn.dataset.value = opt.value;
      btn.disabled = isDisabled;
      btn.title = opt.value;
      var circle = document.createElement('span');
      circle.className = 'bc-swatch__circle';
      circle.style.backgroundColor = opt.color;
      btn.appendChild(circle);
      if (isDisabled) {
        var slash = document.createElement('span');
        slash.className = 'bc-swatch__slash';
        slash.setAttribute('aria-hidden', 'true');
        btn.appendChild(slash);
      }
      btn.addEventListener('click', function () { onSlotClick(slotIdx, opt, btn); });
      swatches.appendChild(btn);
    });
    row.appendChild(label);
    row.appendChild(swatches);
    return row;
  }

  function onSlotClick(slotIdx, opt, clickedBtn) {
    if (!opt.available) return;
    selectedIds[slotIdx] = opt.variantId;
    var row = document.querySelector('.bc-row[data-slot="' + slotIdx + '"]');
    if (!row) return;
    row.querySelectorAll('.bc-swatch').forEach(function (s) { s.classList.remove('bc-swatch--active'); });
    clickedBtn.classList.add('bc-swatch--active');
    var nameEl = row.querySelector('.bc-label__color');
    if (nameEl) nameEl.textContent = opt.value;

    // Slot 0 is the "main" colour of the bundle — keep the product's actual
    // selected variant (price, main image/gallery, hidden option input) in
    // sync with it. The native variant picker only updates any of that for
    // its own top-level swatch clicks, not for picks made inside these
    // per-slot bundle rows, so that update has to happen here.
    if (slotIdx === 0) syncTopVariantToColor(opt.value, opt.variantId);
  }

  // Drives the theme's own top-level variant picker instead of duplicating
  // its update logic (price, hidden option input, media gallery, etc.) —
  // find the matching top swatch and click it for real. Suppressed via
  // suppressTopSwatchSync so that click doesn't loop back through
  // onTopSwatchClick and re-sync every OTHER slot back to this colour too.
  function syncTopVariantToColor(colorValue, variantId) {
    var topBtn = document.querySelector(SEL_VISUAL_BTN + '[data-value="' + colorValue + '"]');
    if (topBtn && !topBtn.closest(SEL_BC_WRAP) && !topBtn.classList.contains('disabled') && !topBtn.classList.contains('active')) {
      suppressTopSwatchSync = true;
      topBtn.click();
      suppressTopSwatchSync = false;
      return;
    }
    // Fallback if no matching top swatch exists — at least keep the image right.
    updateMainImage(variantId);
  }

  function updateMainImage(variantId) {
    var variant = allVariants.find(function (v) { return v.id === variantId; });
    if (!variant) return;
    document.querySelectorAll('media-gallery').forEach(function (mediaGallery) {
      if (mediaGallery.setActiveMedia) {
        mediaGallery.setActiveMedia(variant);
        return;
      }
      if (!variant.featured_media || !mediaGallery.slider) return;
      var slides = mediaGallery.slider.slides || [];
      for (var i = 0; i < slides.length; i++) {
        var mediaElement = slides[i].querySelector('[data-media-id]');
        if (mediaElement && mediaElement.dataset.mediaId == variant.featured_media.id) {
          mediaGallery.slider.slideTo(i);
          break;
        }
      }
    });
  }

  function attachCartIntercept() {
    if (interceptAttached) return;
    interceptAttached = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[name="add"], button[type="submit"].add-to-cart');
      if (!btn) return;

      var form = btn.closest(SEL_PRODUCT_FORM);
      if (!form) return;

      if (activeQty <= 1) return;

      var wrap = document.querySelector(SEL_BC_WRAP);
      if (!wrap || getComputedStyle(wrap).display === 'none') return;

      e.preventDefault();
      e.stopImmediatePropagation();

      doCartAdd(form);
    }, true); // capture phase — runs before Minimog's click handler
  }

  // Deduplicated, sorted list of variant ids — used to compare "the set of
  // colours chosen" between two bundles regardless of order or how many of
  // each colour.
  function colorSet(variantIds) {
    var seen = {};
    var out = [];
    variantIds.forEach(function (id) {
      if (!seen[id]) { seen[id] = true; out.push(id); }
    });
    return out.sort(function (a, b) { return a - b; });
  }

  function sameColorSet(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

  // Finds an existing bundle (for this product) whose lines cover the exact
  // same set of colours as `chosenIds` — re-adding the same combination
  // should grow that bundle's quantities, not create a visually separate one.
  function findMatchingBundle(cart, productId, chosenIds) {
    var newSet = colorSet(chosenIds);
    var groups = {};
    cart.items.forEach(function (item) {
      var bundleId = item.properties && item.properties._bundle_id;
      if (!bundleId || item.product_id !== productId) return;
      (groups[bundleId] = groups[bundleId] || []).push(item);
    });
    for (var bundleId in groups) {
      if (sameColorSet(colorSet(groups[bundleId].map(function (i) { return i.variant_id; })), newSet)) {
        return groups[bundleId];
      }
    }
    return null;
  }

  function mergeIntoBundle(existingItems, chosenIds) {
    var addCounts = {};
    chosenIds.forEach(function (id) {
      addCounts[id] = (addCounts[id] || 0) + 1;
    });
    var updates = {};
    var touchedKeys = {};
    existingItems.forEach(function (item) {
      updates[item.key] = item.quantity + (addCounts[item.variant_id] || 0);
      touchedKeys[item.key] = true;
    });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates }),
    }).then(function (res) { return res.json(); }).then(function (cart) {
      // /cart/update.js resolves with the whole cart, not just the touched
      // lines — reshape to {items: [...]} like /cart/add.js so
      // triggerCartUpdate's `data.items[0]` is actually one of ours.
      return { items: cart.items.filter(function (item) { return touchedKeys[item.key]; }) };
    });
  }

  function addNewBundle(chosenIds) {
    var bundleId = 'bmc_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);

    // Tag each line with the slot it was FIRST chosen at, so the cart can
    // render "Item 1, Item 2, Item 3" in selection order — cart.items order
    // isn't guaranteed to match. Two slots with the same colour get the SAME
    // slot number (their earliest shared index) so their properties stay
    // identical and they still merge into one cart line.
    var firstIndexOf = {};
    var unitQty = {};
    chosenIds.forEach(function (id, idx) {
      if (!(id in firstIndexOf)) firstIndexOf[id] = idx;
      unitQty[id] = (unitQty[id] || 0) + 1;
    });
    // How many units of THIS colour make up one set (e.g. 2 for a colour
    // picked in 2 of 3 slots) — the cart's +/- stepper needs this to scale
    // by the right amount per line instead of always doing +1/-1.
    var items = chosenIds.map(function (id) {
      return {
        id: id,
        quantity: 1,
        properties: { _bundle_id: bundleId, _bundle_slot: String(firstIndexOf[id]), _bundle_unit_qty: String(unitQty[id]) },
      };
    });
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (res) {
      if (!res.ok) return res.text().then(function (t) { throw new Error(t); });
      return res.json();
    });
  }

  function doCartAdd(form) {
    var submitBtn = form.querySelector('[name="add"]') || form.querySelector('[type="submit"]');
    var origText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = '…'; }

    var fallbackId = (swatchData.find(function (c) { return c.available; }) || {}).variantId;
    var chosenIds = selectedIds.map(function (id) { return id || fallbackId; }).filter(Boolean);

    if (!chosenIds.length) {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = origText; }
      return;
    }

    var productId = allVariants[0] && allVariants[0].product_id;

    // checkbox-cross-sell.js defers its own /cart/add.js call to us whenever
    // this multi-colour selector owns the click (see its attachCartIntercept)
    // — pick up whatever it left selected and add it as its own line item.
    var extraItems = (typeof window.getExtraCartItems === 'function') ? window.getExtraCartItems() : [];

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var existingGroup = productId ? findMatchingBundle(cart, productId, chosenIds) : null;
        return existingGroup ? mergeIntoBundle(existingGroup, chosenIds) : addNewBundle(chosenIds);
      })
      .then(function (data) {
        if (!extraItems.length) return data;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: extraItems }),
        }).then(function (res) {
          if (!res.ok) return res.text().then(function (t) { throw new Error(t); });
          return res.json();
        }).then(function () { return data; });
      })
    .then(function (data) {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = origText; }
      triggerCartUpdate(data);
      if (typeof window.resetExtraCartItems === 'function') window.resetExtraCartItems();
    })
    .catch(function (err) {
      console.error('[bundle-multi-color] Cart error:', err.message);
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = origText; }
    });
  }

  function triggerCartUpdate(data) {
    if (window.Shopify && typeof window.Shopify.onItemAdded === 'function') {
      var lineItem = (data && data.items && data.items[0]) ? data.items[0] : data;
      window.Shopify.onItemAdded(lineItem);
      return;
    }
    if (window.MinimogEvents && typeof window.MinimogEvents.emit === 'function') {
      window.MinimogEvents.emit('ON_ITEM_ADDED', data);
    }
  }

  function injectCSS() {
    if (document.getElementById('bc-multi-color-css')) return;
    var s = document.createElement('style');
    s.id = 'bc-multi-color-css';
    s.textContent =
      '.bc-wrap{display:flex;flex-direction:column;gap:12px;margin-top:14px;margin-left:-32px;width:calc(100% + 32px);}' +
      '.bc-row{display:flex;flex-direction:column;gap:8px;}' +
      '.bc-label{font-size:14px;font-weight:400;color:#2D3748;line-height:1.607;}' +
      '.bc-label__brush{font-weight:700;}' +
      '.bc-label__free{display:inline-flex;align-items:center;justify-content:center;margin-left:6px;padding:2px 8px;border-radius:12px;background:#D62E55;color:#fff;font-size:11px;font-weight:700;line-height:16.5px;text-transform:uppercase;letter-spacing:0.5px;vertical-align:middle;}' +
      '.bc-swatches{display:flex;flex-wrap:wrap;align-items:center;gap:12px;}' +
      '.bc-swatch{position:relative;display:flex;align-items:center;justify-content:center;padding:3px;border:1px solid transparent;border-radius:999px;cursor:pointer;background:transparent;transition:border-color .15s ease;flex-shrink:0;}' +
      '.bc-swatch--active{border-color:#000000;}' +
      '.bc-swatch--disabled{opacity:.5;cursor:not-allowed;}' +
      '.bc-swatch__circle{display:block;width:32px;height:32px;border-radius:9999px;box-shadow:inset 0 0 0 1px rgba(0,0,0,.15);}' +
      '.bc-swatch__slash{position:absolute;inset:3px;border-radius:9999px;pointer-events:none;overflow:hidden;}' +
      '.bc-swatch__slash::before{content:"";position:absolute;inset:0;background:linear-gradient(to bottom right,transparent calc(50% - .75px),#CCC9CA calc(50% - .75px),#CCC9CA calc(50% + .75px),transparent calc(50% + .75px));}';
    document.head.appendChild(s);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
}());
